<template lang="pug">
.exmanage
  RadioGroup(v-model="staRadio" type="button").RadioGroup
    Radio(label='实验管理')
    Radio(label='分配日志')
  div(v-if="staRadio=='实验管理'")
    Form(:inline="true",style='padding-top: 30px; text-align:left')
      //- FormItem(label="案例类型：" :label-width="75")
      //- Select(v-model='search.screen')
      //-   Option(label="教师",value="Teacher")
      //-   Option(label="学生",value="Student")
      FormItem(label="关键词：" :label-width="75")
        Input(v-model='search.name')
      FormItem
        Button.button(type="primary" @click="searchQueryCase(1)") 查询
        Button.button(@click='cancelSearchQueryCase') 取消
    ul.case-list
      li(v-for='item in caseList' :title='item.caseName').list
        .Template
          //- Button.button(@click='OpenCaseDialog(item)') 分配实训
          Button.button.b1(type='primary' @click='showExperiment(item)')
            MyIcon(type='a-yulan-01-01')
            .text 实验介绍
          Button.button.b2(type='primary' @click='OpenCaseDialog(item)')
            MyIcon(type='a-paixu-01')
            .text 分配实验
        img(:src='item.caseCover')
        div.t-case-content
          div.case-title {{item.caseName}}
          ul.label-ul
            li.Label(v-for='(v,idx) in item.caseTypes',v-if='idx<=2') {{v}}
          div.Horizontal-line
          p.time 更新时间：{{Dayjs(item.turnoverTime).format("YYYY-MM-DD HH:mm:ss")}}
          //- p.type  {{item.auditStatus}}
    Page.page(@on-change="caseChange" :total="casePageData.totalRecords",
      :page-size="10" :current="casePageData.pageNo" show-elevator show-total)
      span 当前有{{caseList.length}}条数据，共{{casePageData.totalRecords}}条数据
    Modal(v-model="modal1" :closable="false" width="620" :mask-closable="false").dialog
      Form(:inline="true")
        FormItem(label='开始时间' :label-width="75" style="margin-right:0")
          DatePicker(:options="options1",type="datetime",placeholder="选择日期",
            @on-change="time1",:value="timeValue1",format="yyyy-MM-dd HH:mm:ss")
        FormItem(label='结束时间' :label-width="75" style="margin-right:0")
          DatePicker(:options="options1",type="datetime",placeholder="选择日期",
            @on-change="time2",format="yyyy-MM-dd HH:mm:ss",v-model="timeValue2")
      Form
        FormItem(label='实验阶段' :label-width="75")
          Row
            Col( span="12")
              Select(v-model='fromData.distribution',@on-change="finallmethod" multiple style="width:184px")
                Option(v-for="app in list" :label="app.stepName",:value="JSON.stringify(app)",:key="app.id")
              i(class="icon-gantanhao iconfont" style="font-size:14px;color:#999;margin:0 10px")
            Col( span="12")
              span {{!fromData.distribution||fromData.distribution === ""? '请选择需要进行的实验阶段':fromData.distribution.length == list.length ? '将为您分配当前实验的所有阶段' : `将为您分配当前实验的"${fromData.distribution.map(v=>JSON.parse(v)).sort((a, b) => a.sortNo - b.sortNo).map(v=>v.stepName).join(',')}"阶段`}}
      Form(:inline="true")
        FormItem(label='下载报告' :label-width="75")
          Poptip(trigger="hover" content="选择学生是否可下载实训报告")
            i-switch(v-model='fromData.viewReport')
              <span slot="open"></span>
              <span slot="close"></span>
        FormItem(label='查看答案' :label-width="75")
          Poptip(trigger="hover" content="选择学生是否可在报告中查看答案")
            i-switch(v-model='fromData.viewAnswer')
              <span slot="open"></span>
              <span slot="close"></span>
      Form
        FormItem(label='选择班级' :label-width="75")
          div.hideTag
            Tag(style='color:#2A2E36;margin: 2px;background:#F7F7F7;border-color:rgba(210,221,236,1)',
            closable,v-for='(x,index) in ClassList',:key="x",:title="x"
            @on-close='taghandleClose(x,index)')  {{x}}
      div.To-be-allocated-class
        div.classList
          Checkbox(:indeterminate="indeterminate",:value="checkAll",@click.prevent.native="handleCheckAll").classname 全选
          Checkbox(:indeterminate="isIndeterminate[index]",v-for='(c,index) in NoClassList',
          :label='c.className',:key='c.className',
          v-model='CheckboxList[index]',
          class='classname',
          :title="c.className"
          :style="bgcolor[index]"
          @click.prevent.native='singleChange(c.className,index)')  {{c.className}}
        div.StudentList
          CheckboxGroup.checkboxgroup(v-model='fromData.members' v-if="fromData.members.length === 0 && SelectionClass === -1" @on-change="StudentChange(classIndex)")
          CheckboxGroup.checkboxgroup(v-model='fromData.members' v-else @on-change="StudentChange(classIndex)")
            Checkbox.is-checked(v-for='v in NoClassList[classIndex].studentList',:title="v.name"
              :label='v.classMemberPk.userId',:key='v.classMemberPk.userId') {{v.name}}
      div(slot="footer")
        .div(style='color:#FAAD14;display:inline-block;padding-right:30px') * 点击确定前请确认实验分配信息，确定之后该设置将无法更改！
        Button(@click="closeMd1") 取消
        Button(type="primary" @click="indeed()" :loading="loading1") 确定
    Modal.dialog3(v-model="modal3" :closable='true' width='860' :mask-closable="true" :footer-hide='true' )
      p.title() 实验介绍
      div.content(v-html='exIntroduce')
  div(v-else,style="margin-top: 20px")
    Table(:columns="columns1" :data="JournalList")
    Modal(v-model="modal2" :closable="false" width="650").dialog
      Form(:inline="true")
        FormItem(label='开始时间' :label-width="75")
          DatePicker(type="datetime",placeholder="选择日期",:value="fromData2.startTime",
            format="yyyy-MM-dd HH:mm:ss", @on-change="time3")
        FormItem(label='结束时间' :label-width="75")
          DatePicker(type="datetime",placeholder="选择日期",:value="fromData2.endTime",
            format="yyyy-MM-dd HH:mm:ss",@on-change="time4")
        FormItem(label='实验阶段' :label-width="75")
          Select(v-model='chosedistribution2',@on-change="finallmethod2" multiple)
            Option(v-for="(item,index) in list",:label="item.stepName",:key="item.id",:value="item",:disabled="distribution2.includes(item.caseStep) ")
        FormItem(label='下载报告' :label-width="75" v-show="isfinall2")
          Select(v-model='fromData2.viewReport')
            Option(label="允许下载",value="true")
            Option(label="不允许下载",value="false")
        FormItem(label='查看答案' :label-width="75")
          Select(v-model='fromData2.viewAnswer')
            Option(label="允许查看",value="true")
            Option(label="不允许查看",value="false")
      <p style='margin-top: 24px;    color: #f89902;   font-size: 12px;'>注：若延续分配前的阶段采用了智能评分或一键评分，那么延续分配后的阶段也需要进行智能评分或一键评分！</p>

      div(slot="footer")
        Button(@click="isfinall2=true;modal2 = false;chosedistribution2 = []") 取消
        Button(type="primary" @click="indeed2()" :loading="loading2") 确定
    Page.page(@on-change="handleCurrentChange" :total="pageData.totalRecords"
      :page-size="8" :current="pageData.pageNo" show-elevator show-total)
      span 当前有{{JournalListLength}}条数据，共{{pageData.totalRecords}}条数据
</template>
<script>
import { Icon } from "ant-design-vue-findsoft";
import dayjs from "dayjs";
const MyIcon = Icon.createFromIconfontCN({
  scriptUrl: "./static/measureIcon/iconfont.js" // 在 iconfont.cn 上生成
  // scriptUrl: "//at.alicdn.com/t/font_1894666_u8l18mo27q.js" // 在 iconfont.cn 上生成
});
export default {
  components: {
    MyIcon
  },
  data() {
    return {
      options1: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      },
      chosedistribution2: [],
      distribution2: [],
      indeterminate: false,
      /** 是否全选班级 */
      loading1: false,
      Dayjs: dayjs,
      loading2: false,
      checkAll: false,
      casePageData: {},
      bgcolor: [],
      classIndex: 0,
      stuboxlist: [],
      timeValue1: this.getNowFormatDate(),
      timeValue2: "",
      isfinall2: false,
      isfinall: false,
      isIndeterminate: [],
      page: 1,
      list: [],
      distributionSta: 0,
      pageData: {}, // 分页总数
      JournalList: [], // 分配日志列表
      JournalListLength: "", // 分配日志当前页条数
      searchState: false, // 是否是搜索的状态
      startTimeOptions: {}, // 开始日期设置
      endTimeOptions: {}, // 结束日期设置
      studentsList: {}, // 全部待分配学生
      SelectionClass: -1, // 当前选择的班级
      NoClassList: [{ studentList: [] }], // 全部班级
      ClassList: [], // 待分配班级
      CheckboxList: [],
      modal1: false, // 分配实验弹出框显示状态
      modal2: false, // 延续分配弹出框显示状态
      modal3: false, // 实验介绍
      exIntroduce: "", // 实验介绍
      storageCaseData: {},
      updataClass: {},
      fromData: {
        startTime: this.getNowFormatDate(),
        endTime: "",
        distribution: "",
        viewReport: "false",
        viewAnswer: "false",
        members: []
      },
      fromData2: {
        startTime: "",
        endTime: "",
        distribution: "",
        viewReport: "false",
        viewAnswer: "true",
        id: ""
      },
      pageNo: 1,
      staRadio: "实验管理",
      caseList: [],
      search: {
        name: "",
        screen: "Teacher"
      },
      searchsate: false,
      adminColumns: [
        // {
        //   title: "序号",
        //   type: "index"
        // },
        {
          title: "实验名称",
          key: "name",
          width: "264",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    display: "inline-block",
                    width: "100%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    cursor: "pointer"
                  },
                  domProps: {
                    title: params.row.name
                  }
                },
                params.row.name
              )
            ]);
          }
        },
        {
          title: "完成阶段",
          key: "distribution",
          width: 100,
          ellipsis: true
        },
        {
          title: "开始时间",
          key: "startTime",
          width: 176
        },
        {
          title: "结束时间",
          key: "endTime",
          width: 176
        },
        {
          title: "实验班级",
          key: "classNames",
          width: 256,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    display: "inline-block",
                    width: "100%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    cursor: "pointer"
                  },
                  domProps: {
                    title: params.row.classNames
                  }
                },
                params.row.classNames
              )
            ]);
          }
        },
        {
          title: "分配者",
          key: "userId"
        }
      ],
      columns1: [
        // {
        //   title: "序号",
        //   type: "index"
        // },
        {
          title: "实验名称",
          key: "name",
          width: "264",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    display: "block",
                    width: "100%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    cursor: "pointer"
                  },
                  domProps: {
                    title: params.row.name
                  }
                },
                params.row.name
              )
            ]);
          }
        },
        {
          title: "完成阶段",
          key: "distribution",
          width: 95,
          ellipsis: true
        },
        {
          title: "开始时间",
          key: "startTime",
          width: 175,
          render: (h, params) => {
            return h("div", [h("span", dayjs(params.row.startTime).format("YYYY-MM-DD HH:mm:ss"))]);
          }
        },
        {
          title: "结束时间",
          key: "endTime",
          width: 175,
          render: (h, params) => {
            return h("div", [h("span", dayjs(params.row.endTime).format("YYYY-MM-DD HH:mm:ss"))]);
          }
        },
        {
          title: "实验班级",
          key: "classNames",
          width: 185,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    display: "block",
                    width: "100%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    cursor: "pointer"
                  },
                  domProps: {
                    title: params.row.classNames
                  }
                },
                params.row.classNames
              )
            ]);
          }
        },
        {
          title: "分配者",
          key: "createUserId",
          width: "90",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          render: (h, params) => {
            return h(
              "Tooltip",
              {
                props: {
                  content: params.row.createUserName,
                  placement: "top"
                }
              },
              params.row.createUserId
            );
          }
        },
        {
          title: "操作",
          width: "180",
          render: (h, params) => {
            return h("div", [
              h(
                "i",
                {
                  class: "ivu-icon icon-fenpei iconfont",
                  style: "font-size:14px;color:#3A76D2;",
                  props: {
                    type: "text",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      if (params.row.createUserId !== this.$role.code) {
                        this.$Message.error("该实验需由分配者进行操作");
                        return;
                      }
                      if (params.row.toState !== "已结束") {
                        this.$Modal.warning({
                          title: "系统提示",
                          content: "<p>已分配阶段完成后可操作！</p>"
                        });
                      } else if (
                        params.row.distribution === params.row.caseExperimentDistribution
                      ) {
                        this.$Modal.warning({
                          title: "系统提示",
                          content: "<p>已分配至最后阶段，不可延续分配!</p>"
                        });
                      } else {
                        this.condistribution(params.row);
                      }
                    }
                  }
                },
                "延续分配"
              ),
              h(
                "i",
                {
                  style: "padding: 0 12px;color:#D8D8D8;"
                },
                "|"
              ),
              h(
                "i",
                {
                  class: "ivu-icon icon-shanchulaji iconfont",
                  style: "font-size:14px;color:#3A76D2;",
                  props: {
                    type: "text",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.confirmdelete(params.row);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ]
    };
  },
  watch: {
    modal2(newValue) {
      if (!newValue) this.chosedistribution2 = [];
    }
  },
  methods: {
    /** 根据id获得案例介绍 2021年3月3日 后端字段不好给，从单独的接口获得 */
    async getCaseIntroduce(id) {
      if (id) {
        const {
          data: { data }
        } = await this.$http.getCaseIntroduce({ pyId: id });
        // console.log(data, "taaaaaa");
        return data || "暂无";
      }
      return "暂无";
    },
    showExperiment(item) {
      this.getCaseIntroduce(item.id).then(res => {
        this.exIntroduce = res;
        this.modal3 = true;
      });
    },
    changeIndeterminate(val) {
      console.log(val, this.NoClassList);
    },
    /** 全选班级 */
    handleCheckAll() {
      console.log(this.indeterminate);
      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = !this.checkAll;
      }
      this.indeterminate = false;

      if (this.checkAll) {
        this.ClassList = [];
        this.NoClassList.forEach((c, index) => {
          this.singleChange(c.className, index);
        });
      } else {
        this.ClassList = [];
        // eslint-disable-next-line no-unused-vars
        this.CheckboxList = this.CheckboxList.map((item, index) => {
          this.NoClassList[index].studentList.forEach(res => {
            if (this.fromData.members.indexOf(res.classMemberPk.userId) !== -1) {
              this.fromData.members.splice(
                this.fromData.members.indexOf(res.classMemberPk.userId),
                1
              );
            }
          });
          return false;
        });
      }
    },
    getstageIndex(value) {
      return value === this.storageCaseData.caseExperimentDistribution;
    },
    getstageIndex1(value) {
      return value === this.fromData2.caseExperimentDistribution;
    },
    caseChange(page) {
      if (!this.searchState) {
        this.queryCase(page);
      } else {
        this.searchQueryCase(page);
      }
    },
    getNowFormatDate() {
      // 获取当前时间
      const date = new Date();
      const seperator1 = "-";
      const seperator2 = ":";
      const month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
      const strDate = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
      const currentdate = `${date.getFullYear()}${seperator1}${month}${seperator1}${strDate} ${date.getHours()}${seperator2}${date.getMinutes()}${seperator2}${date.getSeconds()}`;
      return currentdate;
    },
    closeMd1() {
      console.log("11111");
      this.bgcolor = [];
      this.CheckboxList.forEach((item, index) => {
        this.CheckboxList[index] = false;
      });
      this.ClassList = [];
      this.timeValue1 = this.getNowFormatDate();
      this.timeValue2 = "";
      this.checkAll = false;

      this.fromData.members = null;
      this.fromData = {
        startTime: this.getNowFormatDate(),
        endTime: "",
        distribution: "",
        viewReport: false,
        viewAnswer: false,
        members: []
      };
      this.$forceUpdate();
      this.modal1 = false;
      // this.loading1 = false;
    },
    finallmethod2() {
      this.fromData2.viewReport = "false";
      // if (
      //   this.fromData2.distribution === "政策制定" &&
      //   this.list.findIndex(this.getstageIndex1) < 1
      // ) {
      //   this.fromData2.viewReport = "true";
      //   this.isfinall2 = false;
      //   return;
      // }
      // if (
      //   this.fromData2.distribution === "政策执行" &&
      //   this.list.findIndex(this.getstageIndex1) < 2
      // ) {
      //   this.fromData2.viewReport = "true";
      //   this.isfinall2 = false;
      //   return;
      // }
      // if (
      //   this.fromData2.distribution === "政策评估" &&
      //   this.list.findIndex(this.getstageIndex1) < 3
      // ) {
      //   this.fromData2.viewReport = "true";
      //   this.isfinall2 = false;
      //   return;
      // }
      // if (this.fromData2.distribution === "政策终结") {
      //   this.fromData2.viewReport = "true";
      //   this.isfinall2 = false;
      //   return;
      // }
      // this.isfinall2 = true;
      if (this.fromData2.distribution === this.fromData2.caseExperimentDistribution) {
        console.log(1);
        // 如果选择最后一个阶段就把确认选择
        this.fromData2.viewReport = "true";
        this.fromData2.viewAnswer = "true";
        this.isfinall2 = true;
      } else {
        this.fromData2.viewAnswer = "true";
        this.isfinall2 = false;
      }
    },
    finallmethod() {
      this.fromData.viewReport = false;
      // if (
      //   this.fromData.distribution === "政策制定" &&
      //   this.list.findIndex(this.getstageIndex) < 1
      // ) {
      //   this.isfinall = false;
      //   // return;
      // }
      // if (
      //   this.fromData.distribution === "政策执行" &&
      //   this.list.findIndex(this.getstageIndex) < 2
      // ) {
      //   this.isfinall = false;
      //   // return;
      // }
      // if (
      //   this.fromData.distribution === "政策评估" &&
      //   this.list.findIndex(this.getstageIndex) < 3
      // ) {
      //   this.isfinall = false;
      //   // return;
      // }
      // if (this.fromData.distribution === "政策终结") {
      //   this.isfinall = false;
      //   // return;
      // }
      //   console.log(this.fromData.distribution);
      //   console.log(this.fromData.distribution);

      if (this.fromData.distribution === this.storageCaseData.caseExperimentDistribution) {
        console.log(1);
        // 如果选择最后一个阶段就把确认选择
        this.fromData.viewReport = true;
        this.fromData.viewAnswer = true;
        this.isfinall = true;
      } else {
        this.fromData.viewAnswer = true;
        this.isfinall = false;
      }
    },
    time3(e) {
      this.fromData2.startTime = e;
    },
    time4(e) {
      this.fromData2.endTime = e;
    },
    condistribution(row) {
      // 延续分配

      this.modal2 = true;
      this.list = [];
      /** 查询当前实验阶段 */
      this.$http.getCaseHallNavbarList(row.pyId).then(res => {
        this.$http.getExperimentById(row.id).then(res2 => {
          if (res.status === 200) {
            this.list = res.data.data;
          }
          if (res2.status === 200) {
            this.distribution2 = res2.data.data.distribution.split(",");
            console.log(this.distribution2, " this.distribution2");
          }
        });
      });
      // this.list = list.data;

      this.fromData2 = {
        caseExperimentDistribution: row.caseExperimentDistribution,
        id: row.id,
        startTime: this.getNowFormatDate(),
        endTime: "",
        distribution: this.list[
          this.list.findIndex(value => {
            return row.distribution === value;
          }) + 1
        ],
        viewReport: "true",
        viewAnswer: "true"
      };
      this.distributionSta = this.list.indexOf(row.distribution);
      this.finallmethod2();
      // this.fromData2.endTime = "";
      this.loading2 = false;
      this.modal2 = true;
    },
    indeed2() {
      this.loading2 = true;
      const t1 = new Date().getTime();
      const t2 = new Date(this.fromData2.endTime).getTime();
      if (t2 < t1) {
        this.loading2 = false;
        this.$Message.error("结束时间需大于当前时间！");
        this.modal2 = true;
        return;
      }

      this.isfinall2 = false;
      this.chosedistribution2 = this.chosedistribution2
        .sort((a, b) => a.sortNo - b.sortNo)
        .map(m => {
          return m.caseStep;
        });
      const data = {
        id: this.fromData2.id,
        distribution: [...this.distribution2, ...this.chosedistribution2].toString(),
        beforeDistribution: this.distribution2.toString(),
        endTime: this.fromData2.endTime,
        startTime: this.fromData2.startTime,
        viewAnswer: this.fromData2.viewAnswer,
        viewReport: this.fromData2.viewReport
      };
      if (!data.startTime) {
        this.loading2 = false;

        return this.$Message.error("请选择开始时间");
      }
      if (!data.endTime) {
        this.loading2 = false;

        return this.$Message.error("请选择结束时间");
      }
      this.$http.updateExperiment(data).then(res => {
        if (res.data.success) {
          this.modal2 = false;
          // this.loading2 = false;
          this.$Message.success("延续分配成功");
          this.queryExperiment();
        } else {
          this.loading2 = false;
          this.$Message.error("分配失败");
          this.modal2 = true;
        }
      });
    },
    confirmdelete(row) {
      if (row.createUserId !== this.$role.code) {
        this.$Message.error("该实验需由分配者进行操作");
        return;
      }
      // 弹出确定删除模态框
      this.$Modal.confirm({
        title: "系统提示",
        content: "<p>你确定要删除这些数据吗?</p>",
        onOk: () => {
          this.deletecase(row);
        }
      });
    },
    deletecase(row) {
      //
      const data = {
        ids: [row.id]
      };
      data.ids = JSON.stringify(data.ids);
      this.$http.removeExperiment(data).then(res => {
        if (this.JournalListLength === 1) {
          this.queryExperiment(this.pageData.pageNo - 1 ? this.pageData.pageNo - 1 : 1);
        } else {
          this.queryExperiment(this.pageData.pageNo);
        }
        if (res.data.success) {
          this.$Message.success("删除成功");
        }
      });
    },
    handleCurrentChange(page) {
      // 分页函数
      // this.listClassRequest(page);
      this.queryExperiment(page);
    },
    queryExperiment(pageNo) {
      // 查询分配日志
      const page = pageNo;
      const data = {
        pageNo: page,
        userId: this.$role.code,
        pageSize: 8
      };
      this.$http.queryExperiment(data).then(res => {
        // console.log(data);
        console.log(this);
        console.log(res);
        this.pageData = res.data.data;
        this.JournalList = res.data.data.list;
        this.JournalListLength = res.data.data.list.length;
        this.JournalList.forEach(ele => {
          const i = ele;
          if (i.classNames) {
            const data2 = JSON.stringify(JSON.parse(i.classNames));
            i.classNames = "";
            JSON.parse(data2).forEach((e, index) => {
              if (index < JSON.parse(data2).length - 1) {
                i.classNames += `${e}、`;
              } else {
                i.classNames += e;
              }
            });
          }
          if (i.adminCreate) {
            i.userId = "admin";
          }
        });
      });
    },
    time1(e) {
      this.fromData.startTime = e;
    },
    time2(e) {
      this.fromData.endTime = e;
    },
    taghandleClose(tag) {
      // console.sun(tag);
      // 删除选中的班级
      //
      // this.isIndeterminate = false
      function find(value) {
        return tag === value.className;
      }
      this.singleChange(tag, this.NoClassList.findIndex(find));
    },
    StudentChange(i) {
      // 操作待分配学生
      console.log("640", i);
      const arr = [];
      this.NoClassList[i].studentList.forEach(item => {
        arr.push(item.classMemberPk.userId);
      });
      const blu = this.fromData.members.find(item => {
        return arr.includes(item);
      });
      console.log(blu);
      if (blu) {
        let onoff = false;
        arr.forEach(item => {
          if (!this.fromData.members.includes(item)) {
            onoff = true;
          }
        });
        console.log(onoff);
        if (onoff) {
          if (this.ClassList.indexOf(this.NoClassList[i].className) === -1) {
            this.ClassList.push(this.NoClassList[i].className);
          }
          this.isIndeterminate[i] = true;
        } else {
          this.isIndeterminate[i] = false;
          this.CheckboxList[i] = true;
        }
      } else {
        this.singleChange(this.NoClassList[i].className, i);
      }
    },
    singleChange(value, d) {
      this.bgcolor = [];
      this.bgcolor[d] = "background:rgba(245,245,245,1)";
      if (this.ClassList.indexOf(value) === -1) {
        this.ClassList.push(value);
        // this.checkAll[d] = true;
      } else {
        this.ClassList.splice(this.ClassList.indexOf(value), 1);
        // this.checkAll[d] = false;
      }
      this.SelectionClass = d;
      this.classIndex = d;
      // this.NoClassList[d].StudentList.forEach(item => {
      //   this.fromData.members.push(item.name);
      // });
      switch (this.ClassList.indexOf(this.NoClassList[d].className)) {
        case -1:
          this.CheckboxList[d] = false;
          this.isIndeterminate[d] = false;
          this.NoClassList[d].studentList.forEach(res => {
            if (this.fromData.members.indexOf(res.classMemberPk.userId) !== -1) {
              this.fromData.members.splice(
                this.fromData.members.indexOf(res.classMemberPk.userId),
                1
              );
            }
          });
          break;
        default:
          this.CheckboxList[d] = true;
          this.isIndeterminate[d] = false;
          this.NoClassList[d].studentList.forEach(res => {
            this.fromData.members.push(res.classMemberPk.userId);
          });
          break;
      }

      if (
        this.ClassList.length === this.CheckboxList.length &&
        this.ClassList.length === this.NoClassList.length
      ) {
        this.indeterminate = false;
        this.checkAll = true;
      } else if (this.ClassList.length === 0) {
        this.indeterminate = false;
        this.checkAll = false;
      } else {
        this.indeterminate = true;
        this.checkAll = false;
      }
    },
    async OpenCaseDialog(data) {
      const { data: list } = await this.$http.getCaseHallNavbarList(data.id);
      this.list = list.data.sort((a, b) => a.sortNo - b.sortNo);
      // 展开分配实验弹出框函数
      this.classIndex = this.NoClassList.length - 1;
      // this.NoClassList[this.NoClassList.length - 1].studentList = [];
      this.fromData.members = [];
      // console.log(this.NoClassList);
      // if (this.$role.role !== "admin") {
      this.loading1 = false;
      this.modal1 = true;
      this.indeterminate = false;
      this.storageCaseData = data;
      this.finallmethod();
      // }
    },
    queryCase(page = 1) {
      // 查询实训
      const data = {
        userId: this.$role.code,
        pageNo: page,
        pageSize: 10
        // customProgress: true,
        // isTeacherExp: this.search.screen === "Teacher"
        // isTeacherExp: true
      };
      // 这里使用listAuditStatusPassExperiment(data)的话,在点击取消按钮的时候是不会正确识别isTeacherExp == true从而导致无法返回数据
      // { userId: "admin", isTeacherExp: true } ||
      this.$http.listAuditStatusPassExperiment(data).then(res => {
        this.casePageData = res.data.data;
        this.caseList = res.data.data.list;
        this.caseList.forEach(e => {
          e.caseTypes = e.caseTypes.split(",");
          e.caseTypes.forEach((x, y) => {
            const str = x.replace(/[|"]/g, "").replace(/\[|]/g, "");
            e.caseTypes.splice(y, 1, str);
          });
        });
        //
      });
    },
    searchQueryCase(page = 1) {
      // 查询实训(搜索框查询)
      const data = {
        pageNo: page,
        pageSize: 10,
        userId: this.$role.code,
        caseName: this.search.name
        // customProgress: true
      };
      // if (!data.isTeacherExp) {
      //   data.auditStatus = "通过";
      // }
      this.$http.listAuditStatusPassExperiment(data).then(res => {
        this.searchState = true;
        //
        this.casePageData = res.data.data;
        this.caseList = res.data.data.list;
        this.caseList.forEach(e => {
          e.caseTypes = e.caseTypes.split(",");
          e.caseTypes.forEach((x, y) => {
            const str = x.replace(/[|"]/g, "").replace(/\[|]/g, "");
            e.caseTypes.splice(y, 1, str);
          });
        });
        // this.caseList = this.caseList.filter(value => {
        //   return value.caseName.indexOf(this.search.name) !== -1;
        // });
        this.searchsate = true;
      });
    },
    cancelSearchQueryCase() {
      // 搜索框取消按钮
      this.searchsate = false;
      this.searchState = false;
      this.search = {
        name: ""
      };
      this.queryCase();
    },
    queryClass() {
      // 查询教的班级
      const data = {
        teacherCode: this.$role.code
      };
      if (this.$role.code === "admin") {
        data.teacherCode = "";
      }
      this.$http.queryClassMemberByTeacherCode(data).then(res => {
        console.log("新接口", res);
        this.NoClassList = res.data.data;
        this.$forceUpdate();
      });
      // this.$http.listClassRequest(data).then(res => {
      //   this.NoClassList = res.data.data.list;
      //   const list = [];
      //   this.NoClassList.forEach((e, index) => {
      //     if (!e.vipClass) {
      //       this.updataClass[e.name] = e;
      //       e.isIndeterminate = false;
      //       this.$http
      //         .listClassMemberRequest({ classRoom_uuid: e.id })
      //         .then(res1 => {
      //           e.StudentList = res1.data.data.list;
      //           e.StudentList.forEach(e1 => {
      //             this.studentsList[e1.code] = e1.name;
      //           });
      //         });
      //     } else {
      //       list.push(index);
      //     }
      //   });
      //   list.forEach(ele => {
      //     const i = ele;
      //     this.NoClassList.splice(i, 1);
      //   });
      //   const data2 = {
      //     StudentList: []
      //   };
      //   this.NoClassList.push(data2);
      //   this.$forceUpdate();
      // });
    },
    indeed() {
      this.loading1 = true;
      const t1 = new Date().getTime();
      const t2 = new Date(this.fromData.endTime).getTime();
      if (t2 < t1) {
        this.loading1 = false;
        this.modal1 = true;
        this.$Message.error("结束时间需大于当前时间！");
        return;
      }
      console.log(this.fromData.distribution);
      if (!this.fromData.distribution || this.fromData.distribution.length === 0) {
        this.loading1 = false;
        this.modal1 = true;
        this.$Message.error("请选择实验阶段");
        return;
        // this.DetermineState = false
      }
      if (
        this.fromData.viewAnswer === "" &&
        this.fromData.distribution.map(v => JSON.parse(v).stepName).includes("政策终结")
      ) {
        this.loading1 = false;
        this.$Message.error("请完整选项");
        this.modal1 = true;
        return;
        // this.DetermineState = false
      }
      if (
        this.fromData.viewReport === "" &&
        this.fromData.distribution.map(v => JSON.parse(v).stepName).includes("政策终结")
      ) {
        this.loading1 = false;
        this.$Message.error("请完整选项");
        this.modal1 = true;
        return;
        // this.DetermineState = false
      }
      if (this.fromData.members.length === 0) {
        this.loading1 = false;
        this.$Message.error("请选择要选择的班级人员!");
        // this.DetermineState = false
        this.modal1 = true;
        return;
      }
      const data = {
        pyId: this.storageCaseData.id,
        createTime: this.storageCaseData.turnoverTime,
        distribution: this.fromData.distribution
          .map(val => JSON.parse(val))
          .sort((a, b) => a.sortNo - b.sortNo)
          .map(v => v.caseStep)
          .join(","),
        endTime: this.fromData.endTime,
        members: JSON.stringify(this.fromData.members),
        name: this.storageCaseData.caseName,
        startTime: this.fromData.startTime,
        userId: this.$role.code,
        viewAnswer: this.fromData.viewAnswer.toString(),
        viewReport: this.fromData.viewReport.toString()
      };
      if (this.$role.code === "admin") {
        data.adminCreate = true;
      }
      this.$http.createOrUpdateExperiment(data).then(res => {
        if (res.data.success) {
          this.fromData.distribution = "";
          // this.isfinall = false;
          // this.loading1 = false;
          this.$Message.success("实验分配成功");
          this.closeMd1();
          this.endTimeOptions = {};
          this.ClassList = [];
          // this.$refs.element.handleClear();
          this.$forceUpdate();
          // this.DetermineState = false

          // 分配成功之后再查询分配日志
          this.queryExperiment(1);
        } else {
          this.loading1 = false;
          // this.DetermineState = false
          this.modal1 = true;
        }
      });
    }
  },
  created() {
    this.queryCase();
    this.queryClass();
    this.queryExperiment(1);
    // if (this.$role.role === "admin") {
    //   this.staRadio = "分配日志";
    // }
  }
};
</script>
<style lang="stylus">
.exmanage
  width 100%
  // background red
  text-align left
  overflow hidden
  .ivu-select-selection
    width 162px
    height 32px
    .ivu-select-large
      height 32px
  .ivu-select-selected-value
    height 32px
    line-height 32px
  .ivu-table-wrapper
    border-color #EEF2F5
    .ivu-table:after
      background #EEF2F5
      z-index -99
    .ivu-table:before
      background-color #EEF2F5
    .ivu-table
      background #EEF2F5
      padding-bottom 2px
      font-size 14px
      thead
        tr
          th
            background #EEF2F5
            font-weight bolder
            color #000
      tbody
        tr
          td
            // text-align: center;
            border-top 1px solid transparent
            border-collapse unset
            box-sizing border-box
            height 40px
            &:first-child
              border-left 1px solid transparent
              border-radius 8px 0px 0px 8px
            &:last-child
              border-right 1px solid transparent
              border-radius 0px 8px 8px 0px
          &:last-child
            td
              border-bottom 1px solid transparent !important
  .ivu-table-tip
    tr
      td
        &:last-child
          border-radius 8px 8px 8px 8px !important
  .ivu-page-total
    span
      color #999999
      font-size 14px
  .ivu-page-item-active
    background #57A3F3
    a
      color #FFFFFF
  .RadioGroup
    display block
    text-align left
  .page
    float right
    margin-top 10px
  .button
    display inline-block
    margin-left 10px
    text-align left
  .is-checked
    overflow hidden
    text-overflow ellipsis
    text-align left
    width 50px
  .case-list
    margin-top 48px
    display grid
    grid-template-columns 210px 210px 210px 210px 210px
    grid-column-gap 16px
    .list
      width 210px
      height 253px
      background #fff
      margin 7px
      vertical-align top
      border-radius 4px
      position relative
      .Template
        width 210px
        height 253px
        background #0000004f
        vertical-align top
        border-radius 4px
        // line-height 210px
        position absolute
        text-align center
        display none
        .button
          width 112px
          height 36px
          font-size 14px
          font-family MicrosoftYaHeiUI
          text-align center
          color #ffffff // rgba(58, 118, 210, 1)
          background #1890FF
          .icon
            display inline-block
            width 20px
            height 20px
          .text
            padding-left 5px
            display inline-block
        .b1
          margin-top 74px
        .b2
          margin-top 24px
      &:hover
        .Template
          display block !important
      img
        width 100%
        height 118px
        margin 0 auto
        display block
          .create
            color #fff
            width 48px
            height 48px
            line-height 48px
            border-radius 8px
            background #000
            opacity 0.5
            top 36px
            text-align center
            font-size 18px
            cursor pointer
            position absolute
          .trash
            color #fff
            cursor pointer
            width 48px
            height 48px
            line-height 48px
            position absolute
            right 0
            border-radius 8px
            background #000
            opacity 0.5
            top 36px
            text-align center
            font-size 18px
          .ivu-icon
            color #fff
            font-size 22px
      .Horizontal-line
        background #dddddd
        height 1px
        margin-top 19px
      .label-ul
        display flex
        justify-content flex-start
        margin-top 5px
        .Label
          width 58px
          margin-left 8px
          height 22px
          background rgba(60, 118, 208, 0.1)
          border-radius 2px
          font-size 12px
          font-family MicrosoftYaHeiUI
          color rgba(56, 133, 225, 1)
          text-align center
          overflow hidden
          text-overflow ellipsis
          &:first-child
            margin-left 0px
      .t-case-content
        margin 12px
        .case-title
          font-size 14px
          font-family MicrosoftYaHeiUI
          color rgba(42, 46, 54, 1)
          line-height 21px
          // display -webkit-box
          min-height 41px
          // overflow hidden
          // white-space normal !important
          // text-overflow ellipsis
          // word-wrap break-word
          // -webkit-line-clamp 2
          // -webkit-box-orient vertical
          overflow hidden
          text-overflow ellipsis
          white-space nowrap
        .time
          font-size 12px
          font-family MicrosoftYaHeiUI
          color rgba(42, 46, 54, 0.75)
          line-height 15px
          margin-top 9px
          display inline-block
.dialog
  background red
  ::-webkit-scrollbar
    height 6px
  .hideTag
    width 100%
    height 40px
    border 1px solid #dddddd
    border-radius 5px
    overflow auto
    white-space nowrap
    .ivu-tag
      span
        float left
        display inline-block
        overflow hidden
        text-overflow ellipsis
        white-space nowrap
        max-width 70px
  .To-be-allocated-class
    display grid
    grid-template-columns 20% 80%
    grid-template-rows 200px
    width 87%
    align-content center
    justify-content center
    text-align center
    margin 0 0 0 72px
    border 1px solid #dddddd
    ::-webkit-scrollbar
      width 6px
      background-color #fff
    ::-webkit-scrollbar-thumb
      background-color rgba(9, 187, 138, 0.5)
    ::-webkit-scrollbar-track
      background-color #fff
    .classList
      // background #474747
      // overflow auto
      overflow-x hidden
      font-family MicrosoftYaHeiUI
      color rgba(42, 46, 54, 0.75)
      text-align left
      // padding 10px
      border-right 1px solid #dddddd
      .classname
        overflow hidden
        text-overflow ellipsis
        white-space nowrap
        width 100%
        height 36px
        line-height 36px
        box-sizing border-box
        // background:rgba(245,245,245,1);
        padding 0 0 0 10px
    .StudentList
      padding 10px
      overflow auto
      .checkboxgroup
        align-content center
        justify-content center
        text-align left
        .is-checked
          overflow hidden
          text-overflow ellipsis
          white-space nowrap
          width 100px
  .page
    float right
    margin-top 10px
.dialog3
  .title
    margin 16px //  0 0 32px
    font-size 20px
    color #2A2E36
  .content
    margin 16px 0 16px 16px // 32
    img
        width: 100%;
</style>
